import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (isUserCard) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
  borderBottom: isUserCard ? 'none' : (p) => `1px solid ${p.palette.grey[300]}`,
});

export const companyInformation: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  mr: 2,
  border: (p) => `1px solid ${p.palette.grey[300]}`,
  borderRadius: (p) => p.spacing(1),
  padding: (p) => p.spacing(1),
};

export const contactLink: SxStyleFunc<boolean | undefined> = () => ({
  color: (p) => p.palette.common.black,
  cursor: 'pointer',
});
